export enum ObservationActionTypes {
    API_RESPONSE_SUCCESS = '@@observation/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@observation/API_RESPONSE_ERROR',

    ADD_OBSERVATION = '@@observation/ADD_OBSERVATION',
    EDIT_OBSERVATION = '@@observation/EDIT_OBSERVATION',
    GET_OBSERVATION = '@@observation/GET_OBSERVATION',
    GET_OBSERVATIONS = '@@observation/GET_OBSERVATIONS',
    GET_OBSERVATIONS_STATUS = '@@observation/GET_OBSERVATIONS_STATUS',
    GET_OBSERVATION_LIST = '@@observation/GET_OBSERVATION_LIST',
    GET_OBSERVATION_REPORT = '@@observation/GET_OBSERVATION_REPORT',
    DELETE_OBSERVATION = '@@observation/DELETE_OBSERVATION',
    SEND_EMAIL_OBSERVATION = '@@observation/SEND_EMAIL_OBSERVATION',
    RESET = '@@observation/RESET',
    RESET_SUCCESS = '@@observation/RESET_SUCCESS',
    RESET_ERROR = '@@observation/RESET_ERROR',
}
